import clsx from 'clsx'
import styled from 'styled-components'

import { CommunitiesListAvatarItem } from './communitiesListAvatarItem'
import type { CommunityAvatarProps } from './types'

import { CommunityListBadge } from '../communityListBadge'

const Box = styled.div`
  z-index: 1;
`

const Badge = styled.div`
  top: -0.5rem;
  right: -0.5rem;
`

export const CommunitiesListAvatar = ({
  community,
  className,
  showBadge = false
}: CommunityAvatarProps) => {
  return (
    <Box
      className={clsx(
        className,
        '_d-flex _h-5 _w-5 _align-items-center _justify-content-center _position-relative'
      )}>
      <CommunitiesListAvatarItem community={community} />
      {showBadge ? (
        <Badge className='_position-absolute'>
          <CommunityListBadge />
        </Badge>
      ) : null}
    </Box>
  )
}
